export default class FlexibleDurationPicker extends HTMLElement {
    static readonly MAX_MONTHS = 4;

    #choices: HTMLInputElement[] = [];

    readonly #boundOnClear = (): void => {
        this.#choices.forEach((input) => {
            input.checked = input.id === 'flex_duration_weekend';
        });

        this.dispatchEvent(new Event('change'));
    };

    readonly #boundOnChange = (event: Event): void => {
        const target = event.target as HTMLInputElement | null;

        if (!target || target.name !== 'flex_month' || target.type !== 'checkbox') {
            return;
        }

        const checkedMonths = this.#monthInputs().filter((i) => i.checked);

        if (checkedMonths.length > FlexibleDurationPicker.MAX_MONTHS) {
            target.checked = false;
        }

        this.#updateMonthDisabledState();
    };

    readonly #boundOnPageShow = (): void => {
        this.#choices = Array.from(this.querySelectorAll('input')) as HTMLInputElement[];
        this.#updateMonthDisabledState();
    };

    get type(): string {
        const selected = this.#choices.find(
            (input) => input.name === 'flex_duration' && input.checked
        );
        return selected?.value || '';
    }

    get months(): number[] {
        return this.#choices
            .filter((input) => input.name === 'flex_month' && input.checked)
            .map((input) => Number(input.value));
    }

    protected connectedCallback(): void {
        this.#choices = Array.from(this.querySelectorAll('input')) as HTMLInputElement[];

        this.addEventListener('clear', this.#boundOnClear);
        this.addEventListener('change', this.#boundOnChange);
        window.addEventListener('pageshow', this.#boundOnPageShow);
    }

    protected disconnectedCallback(): void {
        this.removeEventListener('clear', this.#boundOnClear);
        this.removeEventListener('change', this.#boundOnChange);
        window.removeEventListener('pageshow', this.#boundOnPageShow);
    }

    #monthInputs(): HTMLInputElement[] {
        return this.#choices.filter((i) => i.name === 'flex_month' && i.type === 'checkbox');
    }

    #updateMonthDisabledState(): void {
        const months = this.#monthInputs();
        const selectedCount = months.filter((i) => i.checked).length;

        const shouldDisableRest = selectedCount >= FlexibleDurationPicker.MAX_MONTHS;

        months.forEach((input) => {
            input.disabled = shouldDisableRest && !input.checked;

            const chip = input.closest('nh-chip');
            if (chip) {
                chip.toggleAttribute('aria-disabled', input.disabled);
            }
        });
    }
}

if (!customElements.get('nh-flexible-duration-picker')) {
    customElements.define('nh-flexible-duration-picker', FlexibleDurationPicker);
}
